/**
 * Plan Constants
 *
 * Single source of truth for plan configuration values used across the frontend.
 * These constants should stay in sync with shared/plans.json
 */

/**
 * Default number of free credits given to new users (one-time, lifetime allocation)
 * @see shared/plans.json - plans.free.billing.total_free_credits
 */
export const DEFAULT_FREE_CREDITS = 250;

/**
 * Plus plan monthly credits
 * @see shared/plans.json - plans.plus.billing.monthly_included_credits
 */
export const PLUS_MONTHLY_CREDITS = 3500;

/**
 * Ultra plan monthly credits ($36/mo)
 * @see shared/plans.json - plans.ultra.billing.monthly_included_credits
 */
export const ULTRA_MONTHLY_CREDITS = 7500;

/**
 * Pro plan monthly credits ($100/mo)
 * @see shared/plans.json - plans.pro.billing.monthly_included_credits
 */
export const PRO_MONTHLY_CREDITS = 25000;

/**
 * First-month promotional price in cents
 */
export const PROMO_FIRST_MONTH_CENTS = 100;
